<div
    class="carousel-container"
    (touchend)="onTouchEnd()"
    (touchmove)="onTouchMove($event)"
    (touchstart)="onTouchStart($event)"
>
    <div class="carousel-inner" [style.transform]="translateX()">
        @for (image of images(); track $index) {
            <div class="carousel-slide">
                <img
                    fetchpriority="high"
                    imgFallback
                    loading="lazy"
                    [alt]="label()"
                    [attr.aria-label]="label()"
                    [inputSrcSet]="image"
                />
            </div>
        }
    </div>
    @if (images().length >= 2) {
        <div class="carousel-points" [class.isShiftedDownControls]="isShiftedDownControls()">
            @for (image of images(); track $index) {
                <p [class.active]="$index === currentSlide()" (libAccessibleClick)="setCurrentSlide($index)"></p>
            }
        </div>
    }
</div>
